const GradientSvg = props => (
  <svg viewBox="0 0 1258 1136" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
    <g clipPath="url(#gr-a)">
      <rect width={1258} height={1136} fill="#000" rx={49} />
      <g clipPath="url(#gr-b)">
        <path fill="#000" d="M1838 1178.71H-458V-454h2296z" />
        <g filter="url(#gr-c)">
          <ellipse
            cx={944.708}
            cy={521.383}
            fill="#8349FF"
            rx={944.708}
            ry={521.383}
            transform="scale(-1 1) rotate(-6.481 10323.478 13011.487)"
          />
        </g>
        <g filter="url(#gr-d)" opacity={0.7}>
          <ellipse
            cx={1001.63}
            cy={521.383}
            fill="url(#gr-e)"
            rx={1001.63}
            ry={521.383}
            transform="scale(-1 1) rotate(-21.458 2258.36 8320.034)"
          />
        </g>
        <g filter="url(#gr-f)" opacity={0.25}>
          <path
            fill="url(#gr-g)"
            d="M-206.055-144.358C-280.583 133.782 92.165 475.325 626.5 618.5c534.34 143.175 1027.92 33.764 1102.44-244.377 74.53-278.14-298.22-619.683-832.552-762.858C362.053-531.91-131.528-422.499-206.055-144.358Z"
          />
        </g>
        <g filter="url(#gr-h)">
          <path
            fill="url(#gr-i)"
            d="M-258.693 1338.91c-86.066-121.94-90.985-215.01-133.933-357.949-82.903-275.924-21.845-457.128-120.381-727.864-201.056-552.419-548.733 1186.493-54.211 1504.363 310.873 199.82 1220.534 247.72 946.303 0-109.518-98.94-214.337-88.49-338.022-169.02-127.646-83.1-211.924-125.09-299.756-249.53Z"
          />
        </g>
        <g filter="url(#gr-j)">
          <path
            fill="#808FDD"
            d="M1468.28 1422.54c226.1 14.87 373.67 98.33 517.21 292.51 290.78 393.38-1408.12 518.34-1171.519 86.18 149.181-272.49 365.509-397.69 654.309-378.69Z"
          />
        </g>
        <g filter="url(#gr-k)" opacity={0.4}>
          <path
            fill="#7890DF"
            d="M664.982 911.587c-35.027-24.007-26.262-52.926-67.467-76.313-11.663-5.901-26.592-21.73 6.994-37.838 1.26-29.35 133.145-63.329 110.843-95.846-16.418-23.938-39.066-52.324-101.035-73.386-47.779-16.239-105.288-25.19-157.16-31.418-75.138-9.021-149.361-13.236-215.513-11.568-215.653 5.437-351.62 60.932-441.485 121.313-44.507 29.904-65.371 32.176-72.387 31.244-4.126-.549-3.462-2.205 0 0 5.133 3.269 16.418 15.028 27.359 51.478 12.728 42.405-34.9 30.608 9.573 75.668 40.947 41.487-22.016 43.859 37.985 85.152 76.381 52.567-81.43 60.127 38.334 105.527 91.089 34.53-9.286 41.23 96.489 53.36 144.607 16.57 53.837 97.75 115.681 63.18 38.144-21.32 343.45 87.47 269.392 52.81-56.494-26.45 238.777 6.6 169.004-12.57-46.629-12.82 167.357-.64 162.799-20.72-7.71-33.95 60.223-3.19 87.466-29.58 34.803-33.72-96.359-95.92-45.98-124.72 29.015-16.58 29.179-40.391 22.036-64.533-5.744-19.412-22.9-40.659-52.928-61.24Z"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="gr-c"
        width={2837.76}
        height={2014.7}
        x={-1013.69}
        y={652.509}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_19" stdDeviation={239.167} />
      </filter>
      <filter
        id="gr-d"
        width={2860.07}
        height={2172.84}
        x={334.177}
        y={435.292}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_19" stdDeviation={239.167} />
      </filter>
      <filter
        id="gr-f"
        width={2910.64}
        height={2089.75}
        x={-693.874}
        y={-929.994}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_19" stdDeviation={239.167} />
      </filter>
      <filter
        id="gr-h"
        width={2047.56}
        height={2577.47}
        x={-1219.01}
        y={-253.1}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_19" stdDeviation={199.306} />
      </filter>
      <filter
        id="gr-j"
        width={2184.47}
        height={1608.72}
        x={312.954}
        y={942.326}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_19" stdDeviation={239.167} />
      </filter>
      <filter
        id="gr-k"
        width={1820.12}
        height={1444.18}
        x={-673.69}
        y={186.249}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
        <feGaussianBlur result="effect1_foregroundBlur_1_19" stdDeviation={199.306} />
      </filter>
      <linearGradient
        id="gr-e"
        x1={786.055}
        x2={1001.63}
        y1={127.166}
        y2={1042.77}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#938FDB" />
        <stop offset={1} stopColor="#EB3825" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="gr-g"
        x1={1071.7}
        x2={626.499}
        y1={-210.132}
        y2={618.476}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#938FDB" />
        <stop offset={1} stopColor="#EB3825" stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="gr-i"
        x1={-428.501}
        x2={-114.395}
        y1={759.334}
        y2={1669.76}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D7A9D4" stopOpacity={0} />
        <stop offset={1} stopColor="#FFCDFF" />
      </linearGradient>
      <clipPath id="gr-a">
        <rect width={1258} height={1136} fill="#fff" rx={49} />
      </clipPath>
      <clipPath id="gr-b">
        <path fill="#fff" d="M1838 1178.71H-458V-454h2296z" />
      </clipPath>
    </defs>
  </svg>
);

export default GradientSvg;
